var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const findCategoryIndex = /* @__PURE__ */ __name((autocomplete, index) => {
  let offset = 0;
  for (const { options } of autocomplete) {
    if (index - offset < options.length) {
      return options[index - offset];
    }
    offset += options.length;
  }
  return void 0;
}, "findCategoryIndex");

export { findCategoryIndex };
//# sourceMappingURL=find-category-index.js.map
